<script lang="ts">
  import ActivityBadgeBackdrop from "./ActivityBadgeBackdrop.svelte";
  import MobileActivityBadgeContent from "./MobileActivityBadgeContent.svelte";

  export let handleClose: () => void;
</script>

<div>
  <ActivityBadgeBackdrop onClose={handleClose} />
  <div class="mobile-activity-badge">
    <div class="content-container">
      <MobileActivityBadgeContent />
      <button class="close-button" on:pointerup={handleClose}
        ><img
          alt="close-button"
          src={`${__PUBLIC_PATH__}images/icon-close.svg`}
        /></button
      >
    </div>
  </div>
</div>

<style>
  .mobile-activity-badge {
    border-radius: 1rem;
    width: 75%;
    height: 55%;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    background-color: white;
    z-index: 310;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .close-button {
    all: unset;
    position: absolute;
    top: 2.5%;
    right: 2.5%;
  }
</style>
